import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const SupplyOrderPage = lazy(() => import('@/containers/Views/SupplyOrders/SupplyOrderPage'));
const SupplyOrderDetailsPage = lazy(() => import('@/containers/Views/SupplyOrders/SupplyOrderDetailsPage'));
const NewSupplyOrders = lazy(() => import('@/containers/Views/SupplyOrders/NewSupplyOrders'));

const SupplyOrdersRouter = (
  <Route path="supply_orders">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.SupplyOrders} 
          permissions={EBasicActions.Find}
        >
          <SupplyOrderPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path=":supplyOrderId"
      element={(
        <PrivateRoute 
          pageName={EPage.SupplyOrders} 
          permissions={EBasicActions.Find}
        >
          <SupplyOrderDetailsPage />
        </PrivateRoute>
      )}
    />
    <Route 
      path="new"
      element={(
        <PrivateRoute 
          pageName={EPage.SupplyOrders} 
          permissions={EBasicActions.Create}
        >
          <NewSupplyOrders />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default SupplyOrdersRouter;
